import React, { Component } from 'react'
import ReactDom from 'react-dom'
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl'
import getConstants from '../../../../constants'

import { Button } from 'shared-global-ec-uikit/components/dist/react/esm/components/button'
import { Modal } from 'shared-global-ec-uikit/components/dist/react/esm/components/modal'
import { OverlayBody } from 'shared-global-ec-uikit/components/dist/react/esm/components/overlay-body'

import StoresMap from 'components/StoresMap'
import Meta, { createPageTitle } from 'components/Meta'

import StoreInfo from '../../../StoreDetails/components/StoreInfo'

import { DistanceUnit } from 'typings'
import {
  ButtonLayout,
  Keyline,
  LinkText,
} from 'shared-global-ec-uikit/components/dist/react/esm'
import Parser from 'html-react-parser'

const CONSTANTS = getConstants()
const GOOGLE_MAPS_API_KEY = CONSTANTS.GOOGLE_MAPS_API_KEY

type Props = {
  closeLabel: string
  closeTitle: string
  isOpen: boolean
  onClose: (open: boolean) => void
  store: Components.Schemas.StoreDetail
} & WrappedComponentProps

type State = {
  isMounted: boolean
}

const drawerRoot = document.getElementById('drawer-root')

class StoreDetailsDrawer extends Component<Props, State> {
  state = { isMounted: false }

  el: Element

  constructor(props: Props) {
    super(props)
    this.el = document.createElement('div')
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    drawerRoot && drawerRoot.appendChild(this.el)

    this.setState(
      { isMounted: true },
      () => drawerRoot && drawerRoot.appendChild(this.el),
    )
  }

  componentWillUnmount() {
    drawerRoot && drawerRoot.removeChild(this.el)
  }

  render() {
    const {
      closeLabel,
      closeTitle,
      isOpen = false,
      onClose,
      store,
      intl,
    } = this.props

    if (!this.state.isMounted || !store) {
      return null
    }

    const detailMap = (
      <StoresMap
        className="map-container"
        apiKey={GOOGLE_MAPS_API_KEY}
        dimensions={{ width: '100%', height: 326 }}
        initialCenter={{
          latitude: Number(store.latitude),
          longitude: Number(store.longitude),
        }}
        initialZoom={CONSTANTS.GEO_COORDINATES.INITIAL_ZOOM_DETAILS_PAGE}
        storeList={[store]}
        intlMessages={{
          searchThisArea: intl.formatMessage({
            id: 'text_search_this_area',
          }),
          getDirections: intl.formatMessage({
            id: 'text_showdirection',
          }),
          distanceAway:
            CONSTANTS.DISTANCE_UNIT === DistanceUnit.MILE
              ? intl.formatMessage({ id: 'text_mile' })
              : intl.formatMessage({ id: 'text_km' }),
        }}
      />
    )

    const detailContents = (
      <OverlayBody>
        <StoreInfo storeInfo={store} />
      </OverlayBody>
    )

    const detailContentsNoOverlay = (
      <>
        {store.comment2 && (
          <>
            <LinkText
              href={Parser(store.comment2)}
              emphasize={false}
              element="a"
              target="_blank"
              className="fr-ec-mb-spacing-02"
            >
              {intl.formatMessage({
                id: 'text_store_locator_opening_fliyer_link',
              })}
            </LinkText>
            <Keyline className="shared-global-ec-uikit-mt-spacing-03" />
          </>
        )}
        <StoreInfo storeInfo={store} />
      </>
    )

    const { name } = store
    const detailProps = {
      isOpen,
      closeLabel,
      closeTitle,
      title: name,
      onRequestClose: onClose,
      labelElement: 'h1',
    }

    const detailsPreview = () => (
      <>
        <Meta
          title={createPageTitle(name, intl)}
          description={`${name} ${intl.formatMessage({
            id: 'text_store_locator_details_meta_description',
          })}`}
        />
        <Modal
          variant="large"
          // TODO: Disabling trapFocus is either a DS bug, or an implementation quirk - requires investigation
          trapFocus={false}
          titleId="store_preview_modal"
          {...detailProps}
          fullWidthContent={detailMap}
          fullWidthContentPosition="top"
          footer={
            <ButtonLayout variant="horizontal">
              <Button element="button" variant="primary" onClick={onClose}>
                <FormattedMessage id="text_ok" />
              </Button>
            </ButtonLayout>
          }
        >
          {detailContentsNoOverlay}
        </Modal>
      </>
    )

    return ReactDom.createPortal(detailsPreview(), this.el)
  }
}

export default injectIntl(StoreDetailsDrawer)
